import { useContext, useMemo } from "react";
import { DropdownOption, NumberedProperty } from "sprint-common-web";

import { TvSeriesAssetsListEpisodeItem } from "../../common/AssetItem";
import { SingleTvSeriesContext, VersionDetails } from "../context/SingleTvSeriesContext";
import { useSingleTvSeriesDetails } from "./useSingleTvSeriesDetails";
import { useTvSeriesAssetsListUrlFilters } from "./useTvSeriesAssetsListUrlFilters";

export const useTvSeriesAssetsListFilters = () => {
    const { tvSeries } = useContext(SingleTvSeriesContext);

    const {
        filters,
        trailersOptions,
        setSeasonId,
        setEpisodeId,
        setVersionsTypeIds,
        setDistributorIds,
        setBrandingIds,
        setStatusIds,
        setPage,
        setPageSize,
        setSort,
        clearFilters,
        setTrailers,
        setAssetTypes,
        setAssetOrigins,
        setAssetRecordTypes,
        setCreatedDateFrom,
        setCreatedDateTo,
        setUpdatedDateFrom,
        setUpdatedDateTo
    } = useTvSeriesAssetsListUrlFilters();

    const { getSeasons, getEpisodes, getVersionDetails } = useSingleTvSeriesDetails();

    const seasons = useMemo<NumberedProperty[]>(() => getSeasons(tvSeries), [tvSeries]);
    const episodes = useMemo<TvSeriesAssetsListEpisodeItem[]>(() => getEpisodes(tvSeries, filters.season), [
        tvSeries,
        filters.season
    ]);

    const versionDetails = useMemo<VersionDetails>(() => getVersionDetails(tvSeries, filters.season, filters.episode), [
        tvSeries,
        filters.season,
        filters.episode
    ]);

    const setSeason = (value?: DropdownOption): void => {
        setSeasonId(value?.key.toString());
    };

    const setEpisode = (value: DropdownOption | undefined): void => {
        setEpisodeId(value?.key.toString());
    };

    const setVersionsTypes = (options?: DropdownOption[]): void => {
        const versionTypeIds = options?.map((option: DropdownOption) => option.key);

        setVersionsTypeIds(versionTypeIds);
    };

    const setDistributors = (options?: DropdownOption[]): void => {
        const distributorIds = options?.map((option: DropdownOption) => option.key);

        setDistributorIds(distributorIds);
    };

    const setBrandings = (options?: DropdownOption[]): void => {
        const brandingIds = options?.map((option: DropdownOption) => option.key);

        setBrandingIds(brandingIds);
    };

    const setStatuses = (statusIds: number[]): void => {
        setStatusIds(statusIds);
    };

    return {
        filters,
        seasons,
        episodes,
        versionDetails,
        trailersOptions,
        setTrailers,
        setSeason,
        setEpisode,
        setVersionsTypes,
        setDistributors,
        setBrandings,
        setStatuses,
        setSort,
        setPage,
        setPageSize,
        clearFilters,
        setAssetTypes,
        setAssetRecordTypes,
        setAssetOrigins,
        setCreatedDateFrom,
        setCreatedDateTo,
        setUpdatedDateFrom,
        setUpdatedDateTo
    };
};
